import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "successMessage", "errorMessage"]

  check() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value

    if (confirmation.length === 0) {
      this.clearMessage()
      return
    }

    const passwordsMatch = password === confirmation
    
    if (passwordsMatch) {
      this.successMessageTarget.classList.remove("hidden")
      this.errorMessageTarget.classList.add("hidden")
      this.confirmationTarget.classList.remove("border-red-500", "focus:ring-red-500")
      this.confirmationTarget.classList.add("border-green-500", "focus:ring-green-500")
    } else {
      this.successMessageTarget.classList.add("hidden")
      this.errorMessageTarget.classList.remove("hidden")
      this.confirmationTarget.classList.remove("border-green-500", "focus:ring-green-500")
      this.confirmationTarget.classList.add("border-red-500", "focus:ring-red-500")
    }
  }

  clearMessage() {
    this.successMessageTarget.classList.add("hidden")
    this.errorMessageTarget.classList.add("hidden")
    this.confirmationTarget.classList.remove("border-red-500", "border-green-500", "focus:ring-red-500", "focus:ring-green-500")
  }
}
